import { Container } from "@components/ui/Container";
import { Section } from "@components/ui/Section";
import styles from "./About.module.css";

const IconHandshake = () => (
  <svg viewBox="0 0 24 24" width={22} height={22} fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
    <path d="M11 17 9 19a2.83 2.83 0 0 1-4-4l5-5 5 5" />
    <path d="m21 3-6 6-5-5" />
    <path d="m18 8 4-4" />
    <path d="M13 17a2.83 2.83 0 0 0 4 0l3-3-5-5-5 5" />
  </svg>
);

const IconBalance = () => (
  <svg viewBox="0 0 24 24" width={22} height={22} fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
    <path d="M12 3v18" />
    <path d="M5 8h14" />
    <path d="M5 8 2 16h6L5 8z" />
    <path d="M19 8l-3 8h6l-3-8z" />
    <path d="M2 16a3 3 0 0 0 6 0" />
    <path d="M16 16a3 3 0 0 0 6 0" />
    <path d="M9 21h6" />
  </svg>
);

const IconShield = () => (
  <svg viewBox="0 0 24 24" width={22} height={22} fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
    <path d="M12 3l8 3v6c0 5-3.5 8.5-8 9-4.5-.5-8-4-8-9V6l8-3z" />
    <path d="M9 12l2 2 4-4" />
  </svg>
);

const values = [
  {
    Icon: IconHandshake,
    title: "Asesoría humana",
    body: "Cada cliente tiene un productor asignado. Sin call centers, sin formularios automáticos.",
  },
  {
    Icon: IconBalance,
    title: "Comparamos por vos",
    body: "Trabajamos con las principales compañías del país y te mostramos opciones reales.",
  },
  {
    Icon: IconShield,
    title: "Acompañamiento en siniestros",
    body: "Te asistimos en la denuncia, el peritaje y la liquidación para que no pierdas tiempo.",
  },
];

type AboutProps = {
  /** Si es true, se renderiza con su propio título (modo home). En la page /nosotros se monta sin header propio. */
  withHeader?: boolean;
};

export function About({ withHeader = true }: AboutProps) {
  const content = (
    <Container>
      <div className={styles.grid}>
        <div className={styles.image} aria-hidden>
          <div className={styles.imageInner}>
            <p className={styles.imageQuote}>
              Un productor <em>asignado</em> por cliente. Sin call centers, sin
              tickets.
            </p>
          </div>
          <div className={styles.kpi}>
            <div className={styles.kpiItem}>
              <strong>+30</strong>
              <span>Años</span>
            </div>
            <div className={styles.kpiItem}>
              <strong>+5.000</strong>
              <span>Clientes</span>
            </div>
            <div className={styles.kpiItem}>
              <strong>24h</strong>
              <span>Cotización</span>
            </div>
          </div>
        </div>

        <div>
          <p className={styles.intro}>
            Somos un equipo de Productores Asesores de Seguros (PAS) matriculados,
            comprometidos con brindar coberturas claras, transparentes y a medida.
            Nuestra prioridad es que entiendas qué estás contratando y por qué.
          </p>
          <div className={styles.values}>
            {values.map((v) => (
              <div key={v.title} className={styles.value}>
                <div className={styles.icon}>
                  <v.Icon />
                </div>
                <div>
                  <h4>{v.title}</h4>
                  <p>{v.body}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </Container>
  );

  if (!withHeader) {
    return <section style={{ paddingBlock: "var(--space-12)" }}>{content}</section>;
  }

  return (
    <Section
      id="nosotros"
      background="alt"
      align="center"
      eyebrow="Quiénes somos"
      title="Una organización de seguros con productores reales"
      description="Más de 30 años acompañando a personas, familias y empresas a tomar mejores decisiones en seguros."
    >
      {content}
    </Section>
  );
}
